import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	beforeLoad({ context }) {
		throw redirect({
			to: context.authAdapter.getState().status === "authenticated" ? "/admin/dashboard" : "/login",
		});
	},
});
